import { Ifilter } from "../../Interfaces/filter";
import { fetchListVerificacion } from "../http-common";

const CategoriaRazon = "CategoriaRazon";

const ComboCategoria = (request: Ifilter, controller = new AbortController()) => {
    return fetchListVerificacion.get(`${CategoriaRazon}/ComboCategoria`, {
        params: request,
        signal: controller.signal,
    });
};
const CategoriaRazonService = {
    ComboCategoria
}

export { CategoriaRazonService };